"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCloseEnrolledLocation_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var AutoCloseEnrolledLocation_Factory = /** @class */ (function () {
    function AutoCloseEnrolledLocation_Factory() {
    }
    AutoCloseEnrolledLocation_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AutoCloseDaysheetTime: model.AutoCloseDaysheetTime,
            Enrolled: model.Enrolled,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            TimeZoneId: model.TimeZoneId,
        };
        return result;
    };
    AutoCloseEnrolledLocation_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AutoCloseDaysheetTime: model.AutoCloseDaysheetTime,
            Enrolled: model.Enrolled,
            LocationId: model.LocationId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            TimeZoneId: model.TimeZoneId,
        };
        return result;
    };
    return AutoCloseEnrolledLocation_Factory;
}());
exports.AutoCloseEnrolledLocation_Factory = AutoCloseEnrolledLocation_Factory;
